import { useState } from 'react';

const projects = [
  {
    id: 0,
    before: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/afe481d4618376c0f3a97f824822f4a7.jpeg',
    after: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/218ef9266eaaa98050693767c2c02442.jpeg',
  },
  {
    id: 1,
    before: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/c915fd6a7c016593e81629365dd3dd6d.jpeg',
    after: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/3dfbe58533694311a7a98d6893a089ee.jpeg',
  },
  {
    id: 2,
    before: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/85a21d59e29b9aa6bbd056094c4ed002.jpeg',
    after: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/f7694b0a13a9b593723687e3d0b0034e.jpeg',
  },
  {
    id: 3,
    before: 'https://public.readdy.ai/ai/img_res/dd1ee0e5e6e91ee3f464fe0969408109.jpg',
    after: 'https://readdy.ai/api/search-image?query=kitchen%20backsplash%20tile%20installation%20with%20handmade%20zellige%20tiles%2C%20warm%20terracotta%20tones%2C%20white%20cabinets%2C%20brass%20faucet%2C%20professional%20interior%20photography%2C%20artisan%20craftsmanship%2C%20clean%20modern%20kitchen&width=800&height=600&seq=aft6&orientation=landscape',
  },
];

export default function Gallery() {
  return (
    <section id="gallery" className="bg-[#F8F9FB] py-16 sm:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-[#0B1F3A]"></div>
            <span
              className="text-[#0B1F3A] text-xs font-semibold tracking-widest uppercase"
              style={{ fontFamily: 'Open Sans, sans-serif' }}
            >
              Transformations
            </span>
          </div>
          <h2
            className="text-[#0B1F3A] text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            View Our Work
          </h2>
          <p
            className="text-[#0B1F3A]/60 text-base sm:text-lg max-w-2xl mx-auto"
            style={{ fontFamily: 'Open Sans, sans-serif' }}
          >
            See the full transformation — every project finished with the same care we'd put into our own home.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10">
          {projects.map((item) => (
            <div key={item.id} className="rounded-2xl overflow-hidden shadow-md bg-white">
              {/* Side-by-side images */}
              <div className="grid grid-cols-2">
                {/* Before */}
                <div className="relative">
                  <div className="w-full h-[320px] sm:h-[400px] overflow-hidden">
                    <img
                      src={item.before}
                      alt="Before"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="bg-black/60 text-white text-xs font-bold px-3 py-1 rounded-full tracking-wide uppercase">
                      Before
                    </span>
                  </div>
                </div>

                {/* After */}
                <div className="relative border-l-2 border-white">
                  <div className="w-full h-[320px] sm:h-[400px] overflow-hidden">
                    <img
                      src={item.after}
                      alt="After"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="bg-[#0B1F3A]/80 text-white text-xs font-bold px-3 py-1 rounded-full tracking-wide uppercase">
                      After
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
